import React from "react";
import { Card, CardBody, Col, Row, CardHeader } from "reactstrap";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import ReactApexChart from "react-apexcharts";

const CustomerGraph = () => {
  const options = {
    chart: {
      id: "apexchart-example",
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: ["Bhaktapur", "Changu", "Madhyapur", "Suryabinayak"],
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
      },
    },
    colors: [], // Define colors for each bar
  };

  const series = [
    {
      name: "series-1",
      data: [7500, 10000, 5555, 4500],
    },
  ];

  return (
    <Card>
      <div className="card-header align-items-center d-flex ">
        <h4 className="card-title mb-0 flex-grow-1 ms-2">
          Customer By Location
        </h4>
        <div className="flex-shrink-end">
          <Link to="#!" className="btn btn-soft-danger btn-sm">
            All
          </Link>
        </div>
      </div>

      <CardBody style={{ minHeight: "425px" }}>
        <ReactApexChart
          height={"100%"}
          options={options}
          series={series}
          type="bar"
          dataColors='["--vz-success"]'
          className="apex-charts h-100"
        />
      </CardBody>
    </Card>
  );
};

export default CustomerGraph;
